<template>
    <router-view v-slot="{ Component, route }">
        <keep-alive v-if="route.name !== 'Login'">
            <component :is="Component" :key="route.name" v-if="route.meta.keepAlive" />
        </keep-alive>
        <component :is="Component" v-if="!route.meta.keepAlive" />
    </router-view>
    <!-- <router-view></router-view> -->
</template>

<script setup></script>

<style></style>
